import * as requestFromServer from "./appointmentsApis";
import Actions from "../../actions";

// coupons -> get coupons select list api
export const getAppointmentsAction = (dataToBeSent, setLoading) => async (dispatch) => {
      setLoading(true);
      const response = await requestFromServer.getAppointments(dataToBeSent);
      if (response) {
        dispatch(Actions.createAction(Actions.GET_APPOINTMENTS_LIST, {appointments: response}));
        setLoading(false);
        return response;
      }
      else {
        setLoading(false)
        return null;
      }
  };

  // appointments -> get appointments by id api
export const getAppointmentsByIdAction =
(dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getAppointmentsById(dataToBeSent);
  if (response) {
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};